import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import MetadataList from "../Components/MetaDataList";
import Pagination from "../Components/Pagination";
import Config from "../config.json";
import ComponentContext from "../Context";
import Faradade2 from "../Images/metaData2.webp";
import { useHash } from "../lib/hooks";
import { useCallAllMetadata } from "../lib/hooks/api";
import Loading from "./Loading";

const pageMeta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | فراداده",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const paginator = (items, currentPage, perPageItems) => {
  const page = currentPage || 1;
  const perPage = perPageItems || 10;
  const offset = (page - 1) * perPage;
  const paginatedItems = items.slice(offset).slice(0, perPageItems);
  const totalPages = Math.ceil(items.length / perPage);

  return {
    page,
    perPage,
    prePage: page - 1 ? page - 1 : null,
    nextPage: totalPages > page ? page + 1 : null,
    total: items.length,
    totalPages: totalPages,
    data: paginatedItems,
  };
};

const ACCEPTABLE_HASHES = ["metadata-list", "metadata-order"];

const MetaData = () => {
  const {
    data: allMetadata,
    isSuccess,
    isLoading,
    isError,
  } = useCallAllMetadata();
  const { ApiDriver } = useContext(ComponentContext);
  const context = useContext(ComponentContext);

  const [formEmail, setFormEmail] = useState("");
  const [formPhone, setFormPhone] = useState("");
  const [formHead, setFormHead] = useState("");
  const [formHeadphone, setFormHeadphone] = useState("");
  const [formOrganization, setFormOrganization] = useState("");
  const [formFaculty, setFormFaculty] = useState("");
  const [formWebsite, setFormWebsite] = useState("");
  const [formFile, setFormFile] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [requesting, setRequesting] = useState(false);
  const [page, setPage] = useState(1);
  const [metadataPageItems, setMetadataPageItems] = useState();
  const [filteredPosts, setFilteredPosts] = useState();
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const selectedTab = useHash(ACCEPTABLE_HASHES);

  const [form, setForm] = useState({});
  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const [formName, setFormName] = useState(
    context.profile
      ? context.profile.first_name + " " + context.profile.last_name
      : "",
  );

  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    if (!formName.trim()) {
      newErrors.name = "نام و نام خانوادگی الزامی است";
      isValid = false;
    }

    if (!formEmail.trim()) {
      newErrors.email = "آدرس ایمیل الزامی است";
      // isValid = false;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formEmail)) {
      newErrors.email = "فرمت ایمیل نامعتبر است";
      isValid = false;
    }

    if (!formPhone.trim()) {
      newErrors.phone = "شماره تماس الزامی است";
      isValid = false;
    } else if (!/^09\d{9}$/.test(formPhone)) {
      newErrors.phone = "فرمت شماره تماس نامعتبر (مثال: 09123456789)";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (field, value) => {
    setErrors(prev => ({ ...prev, [field]: "" }));
    // eslint-disable-next-line
    switch (field) {
      case "name":
        setFormName(value);
        break;
      case "email":
        setFormEmail(value);
        break;
      case "phone":
        setFormPhone(value);
        break;
    }
  };

  function SendOrder() {
    if (!validateForm()) return;

    setRequesting(true);
    const formData = {
      fullname: formName,
      phone: formPhone,
      email: formEmail,
      description: formDescription,
      head_fullname: formHead,
      head_phone: formHeadphone,
      organization: formOrganization,
      faculty: formFaculty,
      file: formFile,
      website: formWebsite,
    };

    ApiDriver.sendMetadataOrder(
      formData,
      (data, meta) => {
        context.notification("سفارش با موفقیت ثبت شد", "success");

        setRequesting(false);
      },
      error => {
        context.notification("مشکلی در ارسال بوجود آمد.", "error");
        console.error(error);
        setRequesting(false);
        if (error.response?.data?.errors) {
          const serverErrors = error.response.data.errors.reduce((acc, err) => {
            acc[err.field] = err.message;
            return acc;
          }, {});
          setErrors(serverErrors);
        }
      },
    );
  }

  function loadNextPage(page) {
    setMetadataPageItems(paginator(filteredPosts, page, 12));
    setPage(page);
  }
  function handleSubmit() {
    const foundedItems = allMetadata?.data.filter(el => {
      if (
        form &&
        form.name &&
        form.name !== "" &&
        form.type &&
        parseInt(form.type) !== 0
      ) {
        return el.title.includes(form.name) && el.type === parseInt(form.type);
      } else if (form.type && parseInt(form.type) !== 0) {
        return el.type === parseInt(form.type);
      } else if (form.name && form.name !== "") {
        return el.title.includes(form.name);
      } else return true;
    });
    setFilteredPosts(foundedItems);
    setMetadataPageItems(foundedItems ? paginator(foundedItems, 1, 20) : []);
    setPage(1);
  }

  useEffect(() => {
    if (allMetadata?.data?.length && !filteredPosts) {
      setFilteredPosts(allMetadata?.data);
      setMetadataPageItems(paginator(allMetadata?.data, 1, 20));
      setPage(1);
    }
  }, [allMetadata, filteredPosts]);

  return (
    <DocumentMeta {...pageMeta}>
      <section className="hero-sample hero-sample-mata">
        <div className="hero-sample-right hero-sample-right-meta">
          <h1>فراداده در پژوهیار</h1>
          <p>
            در بخش فراداده می‌توانید اطلاعات کتاب‌شناختی منابع از قبیل:
            نرم‌افزارهای نور، قرآن، نهج‌البلاغه، صحیفه سجادیه و فراداده موضوعی
            را با یک کلیک در نرم‌افزار پژوهیار ذخیره کنید. در این صورت به حجم
            زیادی از اطلاعات بدون نیاز به جستجو در پایگاه‌های مختلف، دسترسی
            خواهید داشت.
          </p>
        </div>
        <div className="hero-sample-left">
          <img src={Faradade2} alt="downloadImg" />
        </div>
      </section>

      <Container className="d-flex flex-column overflow-hidden text-right metaData-container">
        <Tabs
          defaultActiveKey={selectedTab}
          className="d-flex justify-content-center w-100 custom-tab-content flex-nowrap justify-content-center mb-5">
          <Tab
            eventKey="metadata-list"
            tabClassName="d-flex align-items-center flex-1"
            title={<span className="addon-tabs">فراداده‌ها</span>}>
            {isError ? (
              <div className="error-parent mt-5">
                <p>ارتباط با سرور با مشکل مواجه شد !</p>
                <img
                  className="error-img"
                  src={`${process.env.PUBLIC_URL}/images/errorPic.webp`}
                  alt="error-png"
                />
              </div>
            ) : null}
            {isSuccess && metadataPageItems?.data ? (
              <div className="d-flex flex-column  align-items-center">
                <MetadataList
                  posts={metadataPageItems.data}
                  postsLength={filteredPosts?.length}
                  setField={setField}
                  handleSubmit={handleSubmit}
                />
                <div className="d-flex align-items-center justify-content-center pt-3 w-100">
                  {filteredPosts?.length > 12 ? (
                    <Pagination
                      onPageChange={loadNextPage}
                      currentPage={page}
                      totalCount={metadataPageItems.total}
                      pageSize={12}
                    />
                  ) : null}
                </div>
              </div>
            ) : null}
            {isLoading ? (
              <div className="pajoohyar-loading">
                <Loading />
              </div>
            ) : null}
          </Tab>

          <Tab
            eventKey="metadata-order"
            tabClassName="d-flex align-items-center flex-1 justify-content-center"
            title={<span className="addon-tabs">سفارش فراداده</span>}>
            <Row className="my-4 form-container">
              <Col className=" p-4 rounded-3">
                <Row className="g-3 mb-4">
                  <Col md={4}>
                    <div
                      className={`form-floating ${
                        errors.phone && "invalid-input"
                      } `}>
                      <FormControl
                        id="fullname"
                        className={`form-control-lg rounded-3 ${
                          errors.name && "is-invalid"
                        }`}
                        placeholder=" "
                        value={formName}
                        onChange={e =>
                          handleInputChange("name", e.target.value)
                        }
                      />
                      <label className="text-secondary">
                        نام و نام خانوادگی
                      </label>
                      {errors.name && (
                        <div className="invalid-feedback d-block">
                          {errors.name}
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col md={4}>
                    <div
                      className={`form-floating ${
                        errors.phone && "invalid-input"
                      } `}>
                      <FormControl
                        id="email"
                        type="email"
                        className={`form-control-lg rounded-3 ${
                          errors.email && "is-invalid"
                        }`}
                        placeholder=" "
                        value={formEmail}
                        onChange={e =>
                          handleInputChange("email", e.target.value)
                        }
                      />
                      <label className="text-secondary">آدرس ایمیل</label>
                      {errors.email && (
                        <div className="invalid-feedback d-block">
                          {errors.email}
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col md={4}>
                    <div
                      className={`form-floating ${
                        errors.phone && "invalid-input"
                      } `}>
                      <FormControl
                        id="phone"
                        className={`form-control-lg rounded-3 ${
                          errors.phone && "is-invalid"
                        }`}
                        placeholder=" "
                        value={formPhone}
                        onChange={e =>
                          handleInputChange("phone", e.target.value)
                        }
                      />
                      <label className="text-secondary">شماره تماس</label>
                      {errors.phone && (
                        <div className="invalid-feedback d-block">
                          {errors.phone}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="g-3 mb-4">
                  <Col md={8}>
                    <div className="form-floating">
                      <FormControl
                        id="headFullname"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => setFormHead(e.target.value)}
                      />
                      <label className="text-secondary">
                        نام سرپرست سازمان
                      </label>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="form-floating">
                      <FormControl
                        id="headPhone"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => setFormHeadphone(e.target.value)}
                      />
                      <label className="text-secondary">
                        شماره تماس سرپرست
                      </label>
                    </div>
                  </Col>
                </Row>

                <Row className="g-3 mb-4">
                  <Col>
                    <div className="form-floating">
                      <FormControl
                        id="organization"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => setFormOrganization(e.target.value)}
                      />
                      <label className="text-secondary">
                        نام سازمان/دانشگاه
                      </label>
                    </div>
                  </Col>
                </Row>

                <Row className="g-3 mb-4">
                  <Col md={4}>
                    <div className="form-floating">
                      <FormControl
                        id="faculty"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => setFormFaculty(e.target.value)}
                      />
                      <label className="text-secondary">دانشکده مربوطه</label>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="form-floating">
                      <FormControl
                        id="website"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => setFormWebsite(e.target.value)}
                      />
                      <label className="text-secondary">آدرس وبسایت</label>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="file-upload-wrapper">
                      <label htmlFor="file" className="custom-file-upload">
                        <i className="fas fa-cloud-upload-alt me-2"></i>
                        {formFile ? formFile.name : "انتخاب فایل"}
                      </label>
                      <Form.Control
                        id="file"
                        type="file"
                        className="d-none"
                        onChange={e => setFormFile(e.target.files[0])}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <div className="form-floating form-floating-des">
                      <Form.Control
                        id="description"
                        as="textarea"
                        rows="3"
                        className="form-control-lg rounded-3"
                        onChange={e => setFormDescription(e.target.value)}
                        placeholder=" "
                      />
                      <label className="text-secondary">توضیحات تکمیلی</label>
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-end">
                  <Col md={4}>
                    <Button
                      variant="primary"
                      className="w-100 py-2 rounded-pill fw-bold"
                      disabled={requesting}
                      onClick={SendOrder}>
                      {requesting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          در حال ارسال...
                        </>
                      ) : (
                        <>ثبت سفارش</>
                      )}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </Container>
    </DocumentMeta>
  );
};

export default MetaData;
